import './ProfileSectionPreview.css';

export function FormFieldEditor({
  fields,
  values,
  editing,
  onChange,
  snapshotValues,
}: {
  fields: string[];
  values: Record<string, string>;
  editing: boolean;
  onChange: (key: string, value: string) => void;
  snapshotValues?: Record<string, string>;
}) {
  if (fields.length === 0) {
    return <p className="profile-section-preview__muted">編集可能なフィールドがありません</p>;
  }
  return (
    <div className="profile-section-preview__content">
      {fields.map((key) => {
        const snap = snapshotValues?.[key];
        const current = values[key] ?? '';
        const changed = snap != null && snap !== current;
        return (
          <div key={key} className="profile-section-preview__field">
            <div className="profile-section-preview__field-label">{key}</div>
            <div className="profile-section-preview__field-value">
              {editing ? (
                <input
                  className="profile-section-preview__input"
                  value={current}
                  onChange={(e) => onChange(key, e.target.value)}
                />
              ) : (
                <span style={changed ? { color: '#c62828', fontWeight: 600 } : undefined}>
                  {current.trim() || '—'}
                  {changed && snap != null && (
                    <span className="profile-section-preview__muted" style={{ display: 'block', fontSize: 11 }}>
                      比較: {snap}
                    </span>
                  )}
                </span>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
